import React, { createContext, useContext, useReducer } from "react";

const LANGUAGE_KEY = "language";
export const default_locale = "en";
export type SupportedLanguageType = "fr" | "en";
export type SupportedRemoteLanguageType = "fr_FR" | "en_GB";

export interface LanguageState {
  message: string;
  localeCode: SupportedLanguageType;
  remoteCode: SupportedRemoteLanguageType;
}

export enum LanguageActionTypeEnum {
  switch,
}

interface LanguageAction {
  type: LanguageActionTypeEnum;
  data: LanguageState;
}

export const LanguageContext = createContext<LanguageState>(
  getPersistedLanguage()
);
export const LanguageDispatchContext = createContext<Function>(() => {});

function LanguageReducer(
  state: LanguageState,
  action: LanguageAction
): LanguageState {
  switch (action.type) {
    case LanguageActionTypeEnum.switch:
      persistLanguage(action.data);
      return { ...state, ...getPersistedLanguage() };
    default:
      return state;
  }
}

export const LanguageProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(LanguageReducer, initLanguageState());

  return (
    <LanguageContext.Provider value={state}>
      <LanguageDispatchContext.Provider value={dispatch}>
        {children}
      </LanguageDispatchContext.Provider>
    </LanguageContext.Provider>
  );
};

export function useLanguageState(): LanguageState {
  return useContext(LanguageContext);
}

export function useLanguageDispatch() {
  return useContext(LanguageDispatchContext);
}

function initLanguageState(): LanguageState {
  return getPersistedLanguage();
}

function persistLanguage(data: LanguageState): void {
  sessionStorage.setItem(LANGUAGE_KEY, JSON.stringify(data));
}

export function getPersistedLanguage(): LanguageState {
  let json = sessionStorage.getItem(LANGUAGE_KEY);

  if (json !== null && json !== undefined) {
    return JSON.parse(json);
  }

  return {
    message: "language.french",
    localeCode: default_locale,
    remoteCode: "en_GB",
  };
}
